import { differenceInHours } from 'date-fns';
import { storageHelpers } from '../../common/helpers/browser-storage';
import {
    ESRI_ALTERNATIVE_BASEMAPS,
    ESRI_BASEMAPS,
    MAP_ALTERNATIVE_BASEMAP_ACTIVATION_DATE_KEY,
} from '../configurations';
import { Basemap, WebMap } from '../constructors';
import { logMapError } from '../helpers/utils';

export const createInitialWebMap = ({
    webmapPortalId,
    isAlternativeBasemap,
    setMapLoadFailed,
    isEmbeddedBasemap,
    mapMode,
}: {
    webmapPortalId?: string;
    isAlternativeBasemap?: boolean;
    setMapLoadFailed?: (failed: boolean) => void;
    isEmbeddedBasemap?: boolean;
    mapMode?: string;
}): WebMap => {

    if (webmapPortalId) {
        const webmap = new WebMap({
            portalItem: {
                id: webmapPortalId,
            },
        });
        webmap.load().catch((error) => {
            if (error) {
                setMapLoadFailed?.(true);
            }

            logMapError({
                source: 'service',
                event: 'portal_load_error',
                error,
                isEmbeddedMap: isEmbeddedBasemap,
                extraData: {
                    webmapPortalId,
                    isAlternativeBasemap,
                },
            });
        });

        return webmap;
    }

    const baseMapType = isAlternativeBasemap ? ESRI_ALTERNATIVE_BASEMAPS : ESRI_BASEMAPS;
    const basemapStyle = mapMode === 'DARK_MODE' ? baseMapType.DARK : baseMapType.LIGHT;

    const basemap = basemapStyle.isPortalItem
        ? new Basemap({
              portalItem: {
                  id: basemapStyle.id,
              },
          })
        : new Basemap({
              style: {
                  id: basemapStyle.id,
              },
          });

    basemap.load().catch((error) => {
        if (error) {
            setMapLoadFailed?.(true);
        }

        logMapError({
            source: 'service',
            event: 'basemap_load_error',
            error,
            isEmbeddedMap: isEmbeddedBasemap,
            extraData: {
                webmapPortalId,
                isAlternativeBasemap,
            },
        });
    });

    return new WebMap({ basemap });
};

export const shouldLoadAlternativeBasemap = () => {
    let isAlternativeBasemap = false;
    const alternativeBasemapActivationDate = storageHelpers.getItem<string>(
        MAP_ALTERNATIVE_BASEMAP_ACTIVATION_DATE_KEY
    );
    if (alternativeBasemapActivationDate) {
        const alternativeBasemapActivationExpired =
            differenceInHours(new Date(), new Date(alternativeBasemapActivationDate)) > 16;
        if (alternativeBasemapActivationExpired) {
            storageHelpers.removeItem(MAP_ALTERNATIVE_BASEMAP_ACTIVATION_DATE_KEY);
        } else {
            isAlternativeBasemap = true;
        }
    }
    return isAlternativeBasemap;
};
